import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './catalog'; // side-effect: injects pathogen + region records at startup
import { App } from './App';
import './fonts.css';                 // self-hosted Inter (brand sans, matches Lab) — before styles
import './styles.css';                // ui-kit tokens → glass layer → PaCC dark override → chrome styles

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
